import { EventAdditionalApi } from 'api';
import { useAuthMutation } from 'queries/query';

function useCreate() {
  return useAuthMutation(EventAdditionalApi.post);
}

export default useCreate;
